import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDestroyAccessControlMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }) => {
      const response = await axios.delete(`/access_controls/${id}`);

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['accountUserAllowance']);
      queryClient.invalidateQueries(['users']);
      queryClient.resetQueries(['importablePersonnel']);
    },
  });
}
